import { api } from "./client";

export interface WebhookRegistration {
  id: string;
  companyId: string;
  agentId: string | null;
  eventType: string;
  label: string | null;
  url: string;
  active: boolean;
  ipAllowlist: string[] | null;
  createdAt: string;
  updatedAt: string;
}

export interface WebhookRegistrationWithSecret extends WebhookRegistration {
  secret: string;
}

export interface WebhookEvent {
  id: string;
  webhookRegistrationId: string;
  eventType: string;
  payload: Record<string, unknown>;
  status: string;
  error: string | null;
  receivedAt: string;
  processedAt: string | null;
}

export const webhooksApi = {
  list: (companyId: string) =>
    api.get<WebhookRegistration[]>(`/companies/${companyId}/webhooks`),

  create: (companyId: string, data: {
    agentId?: string;
    eventType: string;
    label?: string;
    url: string;
    ipAllowlist?: string[];
  }) =>
    api.post<WebhookRegistrationWithSecret>(`/companies/${companyId}/webhooks`, data),

  remove: (webhookId: string) =>
    api.delete(`/webhooks/${webhookId}`),

  events: (webhookId: string, opts?: { limit?: number }) => {
    const params = new URLSearchParams();
    if (opts?.limit) params.set("limit", String(opts.limit));
    const qs = params.toString();
    return api.get<WebhookEvent[]>(`/webhooks/${webhookId}/events${qs ? `?${qs}` : ""}`);
  },
};
